import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import Paper from '@mui/material/Paper';
import { Button, Stack } from '@mui/material';
import EditModal from './EditModal';
import { useState } from 'react';
import DocumentModal from './DocumentsDialog';
import { useNavigate } from 'react-router';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';

export default function VendorListTable(props) {
  const Navigate = useNavigate();
  const [OpenModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [OpenDocument, setOpenDocument] = useState(false);
  const [UploadedFiles, setUploadedFiles] = useState(null);
  const handleOpenInvoice = (data) => {
    Navigate('/Admin/invoice_details', {
      state: {
        type: data
      }
    });
  };

  const handleOpenModal = (row) => {
    // console.log(row);

    setOpenModal(true);
    setSelectedRow(row.row);
  };

  const handleOpenDocuments = (row) => {
    setOpenDocument(true);
    setUploadedFiles(row);
  };

  const handleCloseDocument = () => {
    setOpenDocument(false);
  };

  const columns = [
    // { field: 'id', headerName: 'ID', width: 70 },
    { field: 'vendor_code', headerName: 'Vendor Code', width: 130 },
    { field: 'vendor_name', headerName: 'Vendor Name', width: 130 },
    {
      field: 'company_name',
      headerName: 'Company Name',
      width: 180
    },
    {
      field: 'address',
      headerName: 'Company Address',
      width: 200
    },
    {
      field: 'pin_code',
      headerName: 'Pincode',
      width: 70
    },
    {
      field: 'mobile_number',
      headerName: 'Mobile Number',
      width: 120
    },
    {
      field: 'email_address',
      headerName: 'Email Address',
      width: 130
    },
    {
      field: 'gst_number',
      headerName: 'GST Number',
      width: 120
    },
    {
      field: 'bank_name',
      headerName: 'Bank name',
      width: 120
    },
    {
      field: 'bank_account_name',
      headerName: 'Bank A/C Name',
      width: 150
    },
    {
      field: 'bank_account_number',
      headerName: 'Bank A/C Number',
      width: 150
    },
    {
      field: 'ifsc_code',
      headerName: 'IFSC Code',
      width: 120
    },
    {
      field: 'vendor_status',
      headerName: 'Status',
      width: 120
    },
    {
      field: 'updated_by',
      headerName: 'Updated By',
      width: 200,
      renderCell: (params) => {
        return params.row.vendor_status_updated_by ? params.row.vendor_status_updated_by.user_name : '';
      }
    },
    {
      field: 'view',
      headerName: 'View',
      width: 120,
      renderCell: (params) => (
        <Stack gap={0.5}>
          <Button
            variant="contained"
            size="small"
            sx={{
              mr: 1,
              backgroundColor: '#592375',
              color: '#FFFFFF',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#592375'
              }
            }}
            color="secondary"
            onClick={() => handleOpenInvoice(params.row)}
          >
            Invoice details
          </Button>
          <Button
            variant="contained"
            size="small"
            sx={{
              mr: 1,
              backgroundColor: '#592375',
              color: '#FFFFFF',
              borderRadius: '6px',
              '&:hover': {
                backgroundColor: '#592375'
              }
            }}
            color="secondary"
            onClick={() => handleOpenDocuments(params.row.uploaded_file)}
          >
            Document
          </Button>
        </Stack>
      )
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 120,
      renderCell: (params) => (
        <Stack gap={0.5}>
          <Button
            variant="outlined"
            size="small"
            sx={{
              mr: 1,
              borderColor: '#688B3A',
              color: '#688B3A',
              borderRadius: '6px',
              '&:hover': {
                borderColor: '#688B3A'
              }
            }}
            // color="secondary"
            onClick={() => handleOpenModal(params)}
            endIcon={<EditOutlinedIcon />}
          >
            Edit
          </Button>
        </Stack>
      )
    }
  ];

  const handleCloseModal = () => {
    setOpenModal(false);
    setSelectedRow(null);
  };
  return (
    <Paper sx={{ height: 450, width: '100%' }}>
      <DocumentModal open={OpenDocument} handleClose={handleCloseDocument} data={UploadedFiles} />
      <EditModal handleSearch={props.handleSearch} data={selectedRow} open={OpenModal} handleClose={handleCloseModal} />
      <DataGrid
        rows={props.data && Array.isArray(props.data.vendors) ? props.data.vendors : []}
        columns={columns}
        sx={{
          '& .MuiDataGrid-columnHeaders': {
            color: '#592375'
          },
          border: 0
        }}
        initialState={{ pagination: { page: props.data ? props.data.page : 0, pageSize: 10 } }}
        pageSizeOptions={[10]}
        getRowId={(row) => row._id}
        disableRowSelectionOnClick
        // sx={{ border: 0 }}
        onPaginationModelChange={(e) => props.handlePageChange(e)}
        rowHeight={80}
      />
    </Paper>
  );
}
